import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const SpeechBubbleIcon = ({
  color = 'foraBlue',
  width = 18,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M13 5.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-3.95 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM5 5.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM15.2 0C16.746 0 18 1.254 18 2.8v7.04c0 1.546-1.254 2.8-2.8 2.8H9.555c-.356 0-.7.136-.96.38L4.37 17v-3.66c0-.387-.313-.7-.7-.7H2.185C.978 12.64 0 11.66 0 10.453V2.8C0 1.254 1.254 0 2.8 0h12.4z"
      />
    </svg>
  </DefaultIconWrapper>
);
